import { useLocation, useNavigate } from "react-router-dom";
import { Home, LayoutTemplate, Settings, Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface MobileBottomNavProps {
  showCreateButton?: boolean;
  onCreateClick?: () => void;
}

export const MobileBottomNav = ({ showCreateButton, onCreateClick }: MobileBottomNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/dashboard", icon: Home, label: "Home" },
    { path: "/templates", icon: LayoutTemplate, label: "Templates" },
    { path: "/settings", icon: Settings, label: "Settings" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 glass border-t border-border/50 z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2 relative">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path === "/dashboard" && location.pathname.startsWith("/base"));
          const Icon = item.icon;
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-col items-center justify-center flex-1 py-1.5 transition-colors",
                isActive ? "text-primary" : "text-muted-foreground"
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] mt-1 font-medium">{item.label}</span>
            </button>
          );
        })}
        
        {showCreateButton && onCreateClick && (
          <Button
            onClick={onCreateClick}
            size="icon"
            className="h-14 w-14 rounded-full shadow-xl absolute -top-7 left-1/2 -translate-x-1/2 gradient-primary border-4 border-background"
          >
            <Plus className="h-6 w-6" />
          </Button>
        )}
      </div>
    </nav>
  );
};